import get from 'lodash/get';
import profileEntity from '../../entities/profiles/entity';
import logger from '../../../../utils/logger';

const TYPES = {
  GET_CREATOR_PROFILE: 'hiringEvent/GET_CREATOR_PROFILE',
  GET_CREATOR_PROFILE_SUCCESS: 'hiringEvent/GET_CREATOR_PROFILE_SUCCESS',
  GET_CREATOR_PROFILE_ERROR: 'hiringEvent/GET_CREATOR_PROFILE_ERROR',

  UPDATE_FILTER_OPTIONS: 'hiringEvent/UPDATE_FILTER_OPTIONS',
};

const getCreatorProfileById = profileKey => async (dispatch) => {
  try {
    if (profileKey) {
      dispatch({ type: TYPES.GET_CREATOR_PROFILE });
      const response = await profileEntity.api.getProfileByKey(profileKey);
      const profile = get(response, 'data');
      dispatch({ type: TYPES.GET_CREATOR_PROFILE_SUCCESS, payload: profile });
      return profile;
    }
    return null;
  } catch (error) {
    logger.logDebug('Encountered error while get profile', error);
    dispatch({ type: TYPES.GET_CREATOR_PROFILE_ERROR, payload: error });
    return null;
  }
};

const updateFilterOptions = options => (dispatch) => {
  dispatch({ type: TYPES.UPDATE_FILTER_OPTIONS, payload: options });
};


export {
  TYPES,
  getCreatorProfileById,
  updateFilterOptions,
};

export default {
  TYPES,
  getCreatorProfileById,
  updateFilterOptions,
};
